import React from 'react'
import styles from './style.module.scss'
import Slider from '@shared/components/slider'
import PropTypes from 'prop-types'

function BallRenderer({ ball, styles }) {
  const isNumeric = !isNaN(ball)

  switch (true) {
    case ball === '6':
      return <span className={`${styles.run} ${styles.greenSix} text-white`}>{ball}</span>

    case ball === '4':
      return <span className={`${styles.run} ${styles.greenSix} bg-success border-success text-white`}>{ball}</span>

    case ball === 'w':
      return <span className={`${styles.run} ${styles.redSix} text-white`}>{ball.toUpperCase()}</span>

    case ball === '4lb' || ball === '4b':
      return <span className={`${styles.run} ${styles.highlight} bg-info border-info`}>{ball}</span>

    case ball === '0':
      return <span className={`${styles.run} ${styles.greyDot}`}></span>

    case isNumeric && ((ball > 0 && ball < 4) || ball === 5 || ball > 6):
      return <span className={`${styles.run} ${styles.greySix} ${styles.highlight} bg-info border-info`}>{ball}</span>

    default:
      return <span className={styles.run}>{ball || '-'}</span>
  }
}

BallRenderer.propTypes = {
  ball: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object.isRequired
}

function ScoreTimeLine({ timeline }) {
  return (
    <div className={styles.scoreTimeLine}>
      <h6 className={styles.scoreTimeLineHeading}>Timeline</h6>
      <section className={`${styles.recentOver} text-center align-items-center position-relative overflow-hidden`}>
        <div className={`${styles.overSlider} over-slider xsmall-text`}>
          <Slider
            nav
            gap={0}
            navTransparent={true}
            destroyBelow={1199}
            customNextArrow={styles.customNextArrow}
            customPrevArrow={styles.customPrevArrow}
            smallArrow={true}
          >
            {timeline?.map((ball, index) => (
              <React.Fragment key={index}>
                <div>
                  <div className={`${styles.list} d-flex align-items-center`}>
                    <BallRenderer ball={ball} styles={styles} />
                  </div>
                </div>
              </React.Fragment>
            ))}
          </Slider>
        </div>
      </section>
    </div>
  )
}

ScoreTimeLine.propTypes = {
  timeline: PropTypes.array
}

export default ScoreTimeLine
